import { useNavigate } from "react-router-dom";
import {connect} from "react-redux";

const User_Button_View = (props) => {
    const navigate = useNavigate();
    const handleClick = async() => {
        try {
            navigate("/profile")
        } catch (error) {
            console.log(error);
        }
    }
    return(
        <button className={`user_follow customizecolorchange_hover customizecolorchange_${props.color_button}`} onClick={() => handleClick()}>View</button>
    )
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button
    }
}
export default connect(mapStateToProps)(User_Button_View);